module.exports = __webpack_public_path__ + "img/sld_abt_meter_t1_disable.97c69056.svg";